// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n4--","toggleWrap":"styles_toggleWrap__3L0k5","content":"styles_content__3nEHJ","selectAreaCode":"styles_selectAreaCode__j6wI9"};